<template>
  <v-container>
    <v-stepper v-model="stepper">
      <v-stepper-header>
        <v-stepper-step
          step="1"
          :complete="stepper > 1"
        >
          パスワード設定
        </v-stepper-step>
        <v-divider />
        <v-stepper-step
          step="2"
          :complete="stepper > 2"
        >
          ユーザ情報
        </v-stepper-step>
        <v-divider />
        <v-stepper-step
          step="3"
          :complete="stepper > 3"
        >
          登録完了
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <invitation-password
            v-if="user"
            :user="user"
            @toNextStep="nextStep"
          />
        </v-stepper-content>
        <v-stepper-content step="2">
          <invitation-user
            v-if="user"
            :user="user"
            @toNextStep="nextStep"
            @toBackStep="backStep"
          />
        </v-stepper-content>
        <v-stepper-content step="3">
          <invitation-completed
            v-if="user"
            :user="user"
          />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
  import {mapActions} from 'vuex'
  import InvitationPassword from './forms/_Password'
  import InvitationUser from './forms/_User'
  import InvitationCompleted from './forms/_Completed'
  export default {
    name: 'InvitationIndex',
    components: {
      InvitationPassword,
      InvitationUser,
      InvitationCompleted,
    },
    mixins: [],
    data () {
      return {
        stepper: 1,
        user: {
          id: null,
          loginId: null,
          password: null,
          passwordConfirmation: null,
          name: null,
          name_furigana: null,
          affiliation: null,
          post: null,
          phone_number: null,
          mobile_number: null,
          role: null,
          email: null,
          avatar: null,
        },
      }
    },
    created() {
      this.editUser({ token: this.$route.params.token }).then((content) => {
        if(content.status){
          this.user = content.user
        }else{
          this.$router.replace('notfound')
        }
      })
    },
    methods: {
      ...mapActions('DriverActivate', {
        editUser: 'edit',
      }),
        nextStep () {
        this.stepper++
      },
        backStep () {
        this.stepper--
      },
    },
  }
</script>

<style scoped lang="scss">
</style>


